import * as fromDatatype from "../datatype-library/index";

export interface bl_aat_claim_document_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  claimant_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  expense_payable_to_claimant: boolean;
  claim_item_category_01_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_02_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_03_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_04_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_05_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_code: fromDatatype.VarcharDatatypeInterface;
  claim_item_name: fromDatatype.VarcharDatatypeInterface;
  claim_type: fromDatatype.VarcharDatatypeInterface;
  max_txn_period_in_months: fromDatatype.IntegerDatatypeInterface;
  max_txn_period_in_days: fromDatatype.IntegerDatatypeInterface;
  approval_workflow_type: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  billing_to_customer: boolean;
  billing_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  billing_markup_ratio: fromDatatype.IntegerDatatypeInterface; // 20
  billing_company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  billing_txn_glcode_reference: fromDatatype.VarcharDatatypeInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  expense_cost_center_comp_hdr_guid: fromDatatype.GuidDataFieldInterface;
  expense_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  expense_txn_glcode_reference: fromDatatype.VarcharDatatypeInterface;
  engagement_billing_hdr_guid: fromDatatype.GuidDataFieldInterface;
  engagement_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  engagement_entity_name: fromDatatype.VarcharDatatypeInterface;
  engagement_company_name: fromDatatype.VarcharDatatypeInterface;
  billing_comp_ccy_code: fromDatatype.VarcharDatatypeInterface;
  expense_comp_ccy_code: fromDatatype.VarcharDatatypeInterface;
  doc_currency_code: fromDatatype.VarcharDatatypeInterface;
  has_supporting_document: boolean;
  require_supporting_document: boolean;
  claim_amount_incl_tax: fromDatatype.NumericDatatypeInterface;
  claim_amount_excl_tax: fromDatatype.NumericDatatypeInterface;
  claim_amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  claim_tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  claim_amount_tax_wht: fromDatatype.NumericDatatypeInterface;
  claim_tax_wht_code: fromDatatype.VarcharDatatypeInterface; // 41
  billing_amount_incl_tax: fromDatatype.NumericDatatypeInterface;
  billing_amount_excl_tax: fromDatatype.NumericDatatypeInterface;
  billing_amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  billing_tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  billing_amount_tax_wht: fromDatatype.NumericDatatypeInterface;
  billing_tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  date_billing: fromDatatype.TimestampTzDatatypeInterface;
  date_claim_txn_start: fromDatatype.TimestampTzDatatypeInterface;
  date_expense: fromDatatype.TimestampTzDatatypeInterface;
  date_final_approval: fromDatatype.TimestampTzDatatypeInterface;
  date_withdrawal: fromDatatype.TimestampTzDatatypeInterface;
  claim_cycle_guid: fromDatatype.GuidDataFieldInterface;
  date_added_to_claim_cycle: fromDatatype.TimestampTzDatatypeInterface;
  finance_checking_login_subject: fromDatatype.GuidDataFieldInterface;
  finance_checking_status: fromDatatype.VarcharDatatypeInterface;
  finance_checking_date: fromDatatype.TimestampTzDatatypeInterface;
  finance_checking_remarks: fromDatatype.VarcharDatatypeInterface; // 58
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface; // 71
  expense_cost_center_branch_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category: fromDatatype.VarcharDatatypeInterface;
  engagement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  engagement_fye_guid: fromDatatype.GuidDataFieldInterface;
  project_hdr_guid: fromDatatype.GuidDataFieldInterface;
  org_chart_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entitlement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  is_foreign_ccy: boolean; // 79
  foreign_ccy: fromDatatype.VarcharDatatypeInterface;
  foreign_ccy_claim_amount_incl_tax: fromDatatype.NumericDatatypeInterface;
  foreign_ccy_claim_amount_excl_tax: fromDatatype.NumericDatatypeInterface;
  foreign_ccy_claim_amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  foreign_ccy_claim_tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  foreign_ccy_claim_amount_tax_wht: fromDatatype.NumericDatatypeInterface;
  foreign_ccy_claim_tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  approval_sequence_posting_status: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  claim_status: fromDatatype.VarcharDatatypeInterface; // 91
  is_non_reimbursable: boolean;
  receipt_txn_date: fromDatatype.TimestampTzDatatypeInterface;
  receipt_amount_incl_tax: fromDatatype.NumericDatatypeInterface;
  receipt_amount_excl_tax: fromDatatype.NumericDatatypeInterface;
  receipt_vendor_name: fromDatatype.VarcharDatatypeInterface;
  receipt_reference_no: fromDatatype.VarcharDatatypeInterface;
  attachment_flow_guid: fromDatatype.GuidDataFieldInterface; // deprecated no longer in use replaced by line_attachment_guid
  professional_body_guid: fromDatatype.GuidDataFieldInterface;
  withdrawal_remarks: fromDatatype.TextDatatypeInterface;
  approval_remarks: fromDatatype.TextDatatypeInterface; // 101
  is_rejected: boolean;
  rejection_remarks: fromDatatype.TextDatatypeInterface;
  date_rejection: fromDatatype.TimestampTzDatatypeInterface;
  is_on_hold: boolean;
  on_hold_remarks: fromDatatype.TextDatatypeInterface;
  date_on_hold: fromDatatype.TimestampTzDatatypeInterface;
  date_resubmission: fromDatatype.TimestampTzDatatypeInterface;
  is_fraud: boolean;
  fraud_remarks: fromDatatype.TextDatatypeInterface;
  attended_internal_employee_json: fromDatatype.JsonDatatypeInterface;
  entertainment_details_json: fromDatatype.JsonDatatypeInterface;
  membership_no: fromDatatype.VarcharDatatypeInterface;
  validity_start_date: fromDatatype.TimestampTzDatatypeInterface;
  validity_end_date: fromDatatype.TimestampTzDatatypeInterface;
  calendar_event_hdr_guid: fromDatatype.GuidDataFieldInterface; // 116
  date_claim_txn_end: fromDatatype.TimestampTzDatatypeInterface;
  date_submission: fromDatatype.TimestampTzDatatypeInterface;
  travel_location: fromDatatype.VarcharDatatypeInterface;
  total_travel_days: fromDatatype.NumericDatatypeInterface;
  does_include_breakfast: boolean;
  does_include_lunch: boolean;
  does_include_dinner: boolean;
  does_include_inconvenient: boolean;
  travel_mileage: fromDatatype.NumericDatatypeInterface;
  professional_subscription_guid: fromDatatype.GuidDataFieldInterface;
  membership_type: fromDatatype.VarcharDatatypeInterface;
  claim_doc_line_primary_processor_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_setting_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  risk_score_calc_status: fromDatatype.VarcharDatatypeInterface;
  risk_score: fromDatatype.NumericDatatypeInterface;
  hdr_running_no_1: fromDatatype.VarcharDatatypeInterface;
  date_on_hold_end: fromDatatype.TimestampTzDatatypeInterface;
  latest_reviewed_by_employee_guid: fromDatatype.GuidDataFieldInterface;
  latest_reviewed_by_employee_name: fromDatatype.VarcharDatatypeInterface;
  latest_reviewed_level: fromDatatype.NumericDatatypeInterface;
  latest_reviewed_date: fromDatatype.TimestampTzDatatypeInterface;
  grouped_guid: fromDatatype.GuidDataFieldInterface;
  is_flag: boolean;
  flag_json: fromDatatype.JsonDatatypeInterface;
  final_approval_ready_to_pay: boolean;
  employee_name: fromDatatype.VarcharDatatypeInterface;
  employee_code: fromDatatype.VarcharDatatypeInterface;
  branch_name: fromDatatype.VarcharDatatypeInterface;
  claim_ocr_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  billing_txn_glcode: fromDatatype.VarcharDatatypeInterface;
  billing_txn_glname: fromDatatype.VarcharDatatypeInterface;
  expense_txn_glcode: fromDatatype.VarcharDatatypeInterface;
  expense_txn_glname: fromDatatype.VarcharDatatypeInterface;
  total_resubmission_count: fromDatatype.IntegerDatatypeInterface;
  approval_branch_designation: fromDatatype.VarcharDatatypeInterface;
  expense_cost_center_branch_claimant_engagement_role: fromDatatype.VarcharDatatypeInterface;
  is_statement_uploaded: boolean;
  base_doc_currency_xrate: fromDatatype.NumericDatatypeInterface;
  duplicate_from_rejected: boolean;
  previous_claim_cycle_guid: fromDatatype.GuidDataFieldInterface;
  claimant_claim_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  first_level_approver_action: fromDatatype.VarcharDatatypeInterface;
  finance_review_action: fromDatatype.VarcharDatatypeInterface;
  approval_branch_designation_guid: fromDatatype.GuidDataFieldInterface;
  review_bookmarked: boolean;
  review_bookmarked_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_payment_processing_option: fromDatatype.VarcharDatatypeInterface;
  travel_allowance_details_json: fromDatatype.JsonDatatypeInterface;
  line_attachment_guid: fromDatatype.GuidDataFieldInterface;
  travel_location_json: fromDatatype.JsonDatatypeInterface;
  forex_source_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_aat_claim_document_line_RowClass
  implements bl_aat_claim_document_line_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  claimant_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  expense_payable_to_claimant: boolean;
  claim_item_category_01_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_02_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_03_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_04_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category_05_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_code: fromDatatype.VarcharDatatypeInterface;
  claim_item_name: fromDatatype.VarcharDatatypeInterface;
  claim_type: fromDatatype.VarcharDatatypeInterface;
  max_txn_period_in_months: fromDatatype.IntegerDatatypeInterface;
  max_txn_period_in_days: fromDatatype.IntegerDatatypeInterface;
  approval_workflow_type: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  billing_to_customer: boolean;
  billing_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  billing_markup_ratio: fromDatatype.IntegerDatatypeInterface; // 20
  billing_company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  billing_txn_glcode_reference: fromDatatype.VarcharDatatypeInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  expense_cost_center_comp_hdr_guid: fromDatatype.GuidDataFieldInterface;
  expense_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  expense_txn_glcode_reference: fromDatatype.VarcharDatatypeInterface;
  engagement_billing_hdr_guid: fromDatatype.GuidDataFieldInterface;
  engagement_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  engagement_entity_name: fromDatatype.VarcharDatatypeInterface;
  engagement_company_name: fromDatatype.VarcharDatatypeInterface;
  billing_comp_ccy_code: fromDatatype.VarcharDatatypeInterface;
  expense_comp_ccy_code: fromDatatype.VarcharDatatypeInterface;
  doc_currency_code: fromDatatype.VarcharDatatypeInterface;
  has_supporting_document: boolean;
  require_supporting_document: boolean;
  claim_amount_incl_tax: fromDatatype.NumericDatatypeInterface;
  claim_amount_excl_tax: fromDatatype.NumericDatatypeInterface;
  claim_amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  claim_tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  claim_amount_tax_wht: fromDatatype.NumericDatatypeInterface;
  claim_tax_wht_code: fromDatatype.VarcharDatatypeInterface; // 41
  billing_amount_incl_tax: fromDatatype.NumericDatatypeInterface;
  billing_amount_excl_tax: fromDatatype.NumericDatatypeInterface;
  billing_amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  billing_tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  billing_amount_tax_wht: fromDatatype.NumericDatatypeInterface;
  billing_tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  date_billing: fromDatatype.TimestampTzDatatypeInterface;
  date_claim_txn_start: fromDatatype.TimestampTzDatatypeInterface;
  date_expense: fromDatatype.TimestampTzDatatypeInterface;
  date_final_approval: fromDatatype.TimestampTzDatatypeInterface;
  date_withdrawal: fromDatatype.TimestampTzDatatypeInterface;
  claim_cycle_guid: fromDatatype.GuidDataFieldInterface;
  date_added_to_claim_cycle: fromDatatype.TimestampTzDatatypeInterface;
  finance_checking_login_subject: fromDatatype.GuidDataFieldInterface;
  finance_checking_status: fromDatatype.VarcharDatatypeInterface;
  finance_checking_date: fromDatatype.TimestampTzDatatypeInterface;
  finance_checking_remarks: fromDatatype.VarcharDatatypeInterface; // 58
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface; // 71
  expense_cost_center_branch_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_category: fromDatatype.VarcharDatatypeInterface;
  engagement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  engagement_fye_guid: fromDatatype.GuidDataFieldInterface;
  project_hdr_guid: fromDatatype.GuidDataFieldInterface;
  org_chart_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entitlement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  is_foreign_ccy: boolean; // 79
  foreign_ccy: fromDatatype.VarcharDatatypeInterface;
  foreign_ccy_claim_amount_incl_tax: fromDatatype.NumericDatatypeInterface;
  foreign_ccy_claim_amount_excl_tax: fromDatatype.NumericDatatypeInterface;
  foreign_ccy_claim_amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  foreign_ccy_claim_tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  foreign_ccy_claim_amount_tax_wht: fromDatatype.NumericDatatypeInterface;
  foreign_ccy_claim_tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  approval_sequence_posting_status: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  claim_status: fromDatatype.VarcharDatatypeInterface; // 91
  is_non_reimbursable: boolean;
  receipt_txn_date: fromDatatype.TimestampTzDatatypeInterface;
  receipt_amount_incl_tax: fromDatatype.NumericDatatypeInterface;
  receipt_amount_excl_tax: fromDatatype.NumericDatatypeInterface;
  receipt_vendor_name: fromDatatype.VarcharDatatypeInterface;
  receipt_reference_no: fromDatatype.VarcharDatatypeInterface;
  attachment_flow_guid: fromDatatype.GuidDataFieldInterface; // deprecated no longer in use replaced by line_attachment_guid
  professional_body_guid: fromDatatype.GuidDataFieldInterface;
  withdrawal_remarks: fromDatatype.TextDatatypeInterface;
  approval_remarks: fromDatatype.TextDatatypeInterface; // 101
  is_rejected: boolean;
  rejection_remarks: fromDatatype.TextDatatypeInterface;
  date_rejection: fromDatatype.TimestampTzDatatypeInterface;
  is_on_hold: boolean;
  on_hold_remarks: fromDatatype.TextDatatypeInterface;
  date_on_hold: fromDatatype.TimestampTzDatatypeInterface;
  date_resubmission: fromDatatype.TimestampTzDatatypeInterface;
  is_fraud: boolean;
  fraud_remarks: fromDatatype.TextDatatypeInterface;
  attended_internal_employee_json: fromDatatype.JsonDatatypeInterface;
  entertainment_details_json: fromDatatype.JsonDatatypeInterface;
  membership_no: fromDatatype.VarcharDatatypeInterface;
  validity_start_date: fromDatatype.TimestampTzDatatypeInterface;
  validity_end_date: fromDatatype.TimestampTzDatatypeInterface;
  calendar_event_hdr_guid: fromDatatype.GuidDataFieldInterface; // 116
  date_claim_txn_end: fromDatatype.TimestampTzDatatypeInterface;
  date_submission: fromDatatype.TimestampTzDatatypeInterface;
  travel_location: fromDatatype.VarcharDatatypeInterface;
  total_travel_days: fromDatatype.NumericDatatypeInterface;
  does_include_breakfast: boolean;
  does_include_lunch: boolean;
  does_include_dinner: boolean;
  does_include_inconvenient: boolean;
  travel_mileage: fromDatatype.NumericDatatypeInterface;
  professional_subscription_guid: fromDatatype.GuidDataFieldInterface;
  membership_type: fromDatatype.VarcharDatatypeInterface;
  claim_doc_line_primary_processor_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_setting_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  risk_score_calc_status: fromDatatype.VarcharDatatypeInterface;
  risk_score: fromDatatype.NumericDatatypeInterface;
  hdr_running_no_1: fromDatatype.VarcharDatatypeInterface;
  date_on_hold_end: fromDatatype.TimestampTzDatatypeInterface;
  latest_reviewed_by_employee_guid: fromDatatype.GuidDataFieldInterface;
  latest_reviewed_by_employee_name: fromDatatype.VarcharDatatypeInterface;
  latest_reviewed_level: fromDatatype.NumericDatatypeInterface;
  latest_reviewed_date: fromDatatype.TimestampTzDatatypeInterface;
  grouped_guid: fromDatatype.GuidDataFieldInterface;
  is_flag: boolean;
  flag_json: fromDatatype.JsonDatatypeInterface;
  final_approval_ready_to_pay: boolean;
  employee_name: fromDatatype.VarcharDatatypeInterface;
  employee_code: fromDatatype.VarcharDatatypeInterface;
  branch_name: fromDatatype.VarcharDatatypeInterface;
  claim_ocr_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  billing_txn_glcode: fromDatatype.VarcharDatatypeInterface;
  billing_txn_glname: fromDatatype.VarcharDatatypeInterface;
  expense_txn_glcode: fromDatatype.VarcharDatatypeInterface;
  expense_txn_glname: fromDatatype.VarcharDatatypeInterface;
  total_resubmission_count: fromDatatype.IntegerDatatypeInterface;
  approval_branch_designation: fromDatatype.VarcharDatatypeInterface;
  expense_cost_center_branch_claimant_engagement_role: fromDatatype.VarcharDatatypeInterface;
  is_statement_uploaded: boolean;
  base_doc_currency_xrate: fromDatatype.NumericDatatypeInterface;
  duplicate_from_rejected: boolean;
  previous_claim_cycle_guid: fromDatatype.GuidDataFieldInterface;
  claimant_claim_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  first_level_approver_action: fromDatatype.VarcharDatatypeInterface;
  finance_review_action: fromDatatype.VarcharDatatypeInterface;
  approval_branch_designation_guid: fromDatatype.GuidDataFieldInterface;
  review_bookmarked: boolean;
  review_bookmarked_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_payment_processing_option: fromDatatype.VarcharDatatypeInterface;
  travel_allowance_details_json: fromDatatype.JsonDatatypeInterface;
  line_attachment_guid: fromDatatype.GuidDataFieldInterface;
  travel_location_json: fromDatatype.JsonDatatypeInterface;
  forex_source_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
